import { render, staticRenderFns } from "./WarningUnsuitableStyle.vue?vue&type=template&id=d8eb2bb8"
import script from "./WarningUnsuitableStyle.vue?vue&type=script&lang=js"
export * from "./WarningUnsuitableStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@7.0.0-bridge.0_@babel+core@7.26.7__cac_fzj6xqfhz2iur5pptcdfbzd24y/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports